import React from "react";
import { AccountCard } from "../../../../components/Cards";
import { ListWrapper } from "./styles";
import { AccountsListProps } from "./types";

/**
 * Component displaying a responsive grid of account cards
 */
export const AccountsList: React.FC<AccountsListProps> = ({
  accounts,
  onAccountClick,
}) => {
  if (accounts.length === 0) {
    return null;
  }

  return (
    <ListWrapper role="list" aria-label="Accounts">
      {accounts.map((account) => (
        <li key={account.id}>
          <AccountCard
            account={account}
            handleOnClick={() => onAccountClick(account)}
          />
        </li>
      ))}
    </ListWrapper>
  );
};
